import { Button } from '@client/components/_ui/data-entry/ButtonModern';
import { message } from '@client/components/_ui/feedback/message';
import { useNavigate } from '@client/hooks/navigation/useNavigate';
import { SYSTEM_ORG_IDS } from '@shared/constants';
import { Result } from 'antd';

type Props = {
    error: unknown;
    reset: () => void;
    isPublicSection: boolean;
    orgId: bigint | undefined;
};

export function GlobalErrorView({ error, reset, isPublicSection, orgId }: Props) {
    const navigate = useNavigate();

    if (error) {
        return (
            <div className="fixed inset-0 flex items-center justify-center">
                <Result
                    className="max-w-(--breakpoint-sm)"
                    status="error"
                    title="Something went wrong"
                    subTitle={
                        <>
                            <p>
                                An unexpected error occurred. Our system administrators have been notified and are
                                looking into it. Please try again or return to the home page.
                            </p>
                            <br />
                            <p className="text-sm text-subtle-foreground">
                                Error details: {error instanceof Error ? error.message : String(error)}
                            </p>
                        </>
                    }
                    extra={[
                        <Button
                            key="retry"
                            type="primary"
                            onClick={() => {
                                message.info('Retrying to recover from error...');
                                reset();
                            }}
                        >
                            Try again
                        </Button>,
                        <Button
                            key="home"
                            onClick={() => {
                                // Keep the reset scheduled even if navigation unmounts this view.
                                setTimeout(() => {
                                    reset();
                                }, 2000);

                                message.info('Redirecting...');
                                if (
                                    isPublicSection ||
                                    orgId === undefined ||
                                    orgId < SYSTEM_ORG_IDS.FIRST_VALID_ORG_ID
                                ) {
                                    navigate({ to: '/' });
                                } else {
                                    navigate({ to: '/console/$orgId', params: { orgId } });
                                }
                            }}
                        >
                            Back to home
                        </Button>,
                    ]}
                />
            </div>
        );
    }

    return <div />;
}
